import { colors } from '@ui/colors'
import { IconName, IconProps } from '@ui/elements/Icon'
import { StatusVariant } from '@ui/elements/Status/types'
import { PaymentStatus } from '@order/orderTypes'

export const colorActive = colors.blue[500]
export const colorPayment = colors.black25
export const borderRadius = 24

export const sContainer = 'flex h-24 w-full flex-row items-center gap-4'
export const sInner = 'flex flex-row items-center gap-8 px-8'

export const statusToBadgeVariant: Record<PaymentStatus, StatusVariant> = {
  completed: 'success',
  initialized: 'warning',
  waiting: 'warning',
  draft: 'neutral',
  error: 'danger',
}

export const statusToIcon: Record<PaymentStatus, IconName> = {
  completed: 'check',
  initialized: 'clock',
  waiting: 'loader-2', // using <Loader /> component
  draft: 'clock',
  error: 'alert-triangle',
}

export const statusIconProps: Partial<IconProps> = {
  size: 32,
  color: colors.black25,
}
